export var EStepCodes = /*#__PURE__*/function (EStepCodes) {
  EStepCodes["Topic"] = "topicStep";
  EStepCodes["CommonForm"] = "commonFormStep";
  EStepCodes["ModerationInitial"] = "moderationInitialStep";
  EStepCodes["ModerationIssues"] = "moderationIssuesStep";
  EStepCodes["ModerationFinal"] = "moderationFinalStep";
  EStepCodes["ComplaintFromOwnerProperty"] = "complaintFromOwnerPropertyStep";
  EStepCodes["ComplaintFromOwnerPhoto"] = "complaintFromOwnerPhotoStep";
  EStepCodes["OfferComplaintInitial"] = "offerComplaintInitialStep";
  EStepCodes["OfferComplaintFinal"] = "offerComplaintFinalStep";
  EStepCodes["Login"] = "loginStep";
  EStepCodes["ChangedPhoneInitial"] = "changedPhoneInitialStep";
  EStepCodes["ChangedPhoneSearcherFinal"] = "changedPhoneSearcherFinalStep";
  EStepCodes["ChangedPhoneEmployeeFinal"] = "changedPhoneEmployeeFinalStep";
  EStepCodes["ChangedPhoneFinal"] = "changedPhoneFinalStep";
  EStepCodes["PartnerRewardsInitial"] = "partnerRewardsInitial";
  EStepCodes["XmlUnloading"] = "xmlUnloadingStep";
  EStepCodes["VillageRequest"] = "villageRequestStep";
  EStepCodes["VillageAdding"] = "villageAddingStep";
  EStepCodes["VillageEditing"] = "villageEditingStep";
  EStepCodes["CountrysideBuildersProjectRequest"] = "countrysideBuildersProjectRequestStep";
  return EStepCodes;
}({});